// extracted by mini-css-extract-plugin
export default {"container":"hawk-no-deals-container","comparison":"hawk-no-deals-comparison"};